import React from "react";
import { PILLARS } from "@/data/landing";
import { Reveal } from "@/components/landing/primitives";

export const PillarsSection = () => (
  <section id="program" data-testid="pillars-section" className="py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-sm tracking-wider uppercase font-semibold text-afwn-green">The Program</p>
        <h2 className="mt-3 font-heading font-light tracking-tight text-4xl lg:text-5xl max-w-2xl">A specialized path for your journey</h2>
        <p className="mt-4 text-lg text-afwn-slate max-w-2xl">Three focused programs, each with a full year of weekly training, journaling, and dedicated support resources.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8">
        {PILLARS.map((p, i) => (
          <Reveal key={p.key} i={i}>
            <div data-testid={`pillar-card-${p.key}`} className="group bg-white border border-afwn-navy/5 shadow-sm rounded-3xl overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 h-full">
              <div className="relative overflow-hidden">
                <img src={p.img} alt={p.title} className="w-full aspect-square object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-8">
                <span className="inline-block px-3 py-1 text-xs tracking-wider uppercase rounded-full font-semibold text-white" style={{ background: p.color }}>{p.tag}</span>
                <h3 className="mt-3 font-heading text-3xl" style={{ color: p.color }}>{p.title}</h3>
                <p className="mt-3 text-afwn-slate leading-relaxed">{p.desc}</p>
                <div className="mt-5 flex flex-wrap gap-2 text-xs">
                  {["52-Week Training", "Journaling", "24/7 Assistant"].map((f) => (
                    <span key={f} className="px-3 py-1 rounded-full bg-afwn-surface text-afwn-slate">{f}</span>
                  ))}
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
